import { render, staticRenderFns } from "./create_modal.vue?vue&type=template&id=2df0b397&scoped=true&"
import script from "./create_modal.vue?vue&type=script&lang=js&"
export * from "./create_modal.vue?vue&type=script&lang=js&"
import style0 from "./create_modal.vue?vue&type=style&index=0&id=2df0b397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0b397",
  null
  
)

export default component.exports